import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';
import {DashboardModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiDashboardService extends ApiListDataService<any, any> {

  constructor(http: HttpClient) {
    super(http, '/Dashboard/');
  }
}
